import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer, ScanLine } from "lucide-react";
import { wa, CITIES } from "../mock";
import { ContactLink } from "./ContactLink";
import useNoIndex from "../hooks/useNoIndex";

export default function PosterPage() {
  useNoIndex();
  const { category } = useParams();
  const { search } = useLocation();
  const campaign = new URLSearchParams(search).get("c") || (category ? `poster_${category.toLowerCase()}` : "");

  const isCategory = !!category;
  const origin = window.location.origin;
  const qrValue = isCategory
    ? `${origin}/stock/${encodeURIComponent(category)}?c=${encodeURIComponent(campaign)}`
    : wa();

  const scanLabel = isCategory ? `Scan to see our ${category} stock` : "Scan to chat with us on WhatsApp";
  const heading = isCategory ? `Pre-Owned ${category}` : "We Buy & Sell IT & Office Equipment";

  return (
    <div className="min-h-screen" style={{ background: "var(--cream-2)" }}>
      <style>{`@media print { .no-print { display: none !important; } body { background: #fff !important; } .poster { box-shadow: none !important; border: none !important; } }`}</style>

      <div className="no-print sticky top-0 z-10 border-b bg-white" style={{ borderColor: "var(--line)" }}>
        <div className="mx-auto flex max-w-[820px] items-center justify-between px-5 py-3">
          <span className="font-heading text-[15px] font-bold" style={{ color: "var(--green-950)" }}>
            {isCategory ? `${category} QR poster` : "WhatsApp QR poster"}
          </span>
          <button onClick={() => window.print()} data-testid="poster-print"
                  className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 font-heading text-[14px] font-bold text-white"
                  style={{ background: "linear-gradient(135deg, var(--green-800), var(--green-950))" }}>
            <Printer size={16} /> Print / Save as PDF
          </button>
        </div>
      </div>

      <div className="mx-auto max-w-[820px] px-5 py-8">
        <div className="poster relative overflow-hidden rounded-2xl border bg-white text-center"
             style={{ borderColor: "var(--line)", boxShadow: "var(--shadow)" }}>
          <div className="h-3 w-full" style={{ background: "linear-gradient(90deg, var(--orange-700), var(--orange-500), var(--yellow-500))" }} />
          <div className="px-8 py-10">
            <div className="font-heading text-[38px] font-extrabold leading-none" style={{ color: "var(--green-950)" }}>Kapatia Pvt Ltd.</div>
            <div className="font-hindi mt-2 text-[22px] font-bold" style={{ color: "var(--green-900)" }}>कपाटिया</div>
            <p className="mx-auto mt-3 max-w-[520px] font-heading text-[19px] font-extrabold" style={{ color: "var(--orange-700)" }}>
              {heading}
            </p>

            <div className="mx-auto mt-8 inline-flex items-center gap-2 rounded-full px-4 py-2 font-heading text-[15px] font-extrabold"
                 style={{ background: "var(--green-100)", color: "var(--green-900)" }}>
              <ScanLine size={18} /> {scanLabel}
            </div>

            <div data-testid="poster-qr" className="mx-auto mt-6 w-full max-w-[308px] rounded-2xl border-4 bg-white p-5" style={{ borderColor: "var(--green-900)" }}>
              <QRCodeSVG value={qrValue} size={260} className="h-auto w-full" bgColor="#ffffff" fgColor="#2D6A4F" level="M" includeMargin={false} />
            </div>

            <div className="mt-7 flex justify-center">
              <ContactLink testId="poster-phone" variant="poster" />
            </div>
            <p className="mt-2 font-heading text-[15px] font-bold" style={{ color: "var(--orange-700)" }}>
              {CITIES.join("  \u00b7  ")}
            </p>
            <p className="mt-4 text-[14px]" style={{ color: "var(--muted)" }}>
              Laptops &middot; Desktops &middot; Servers &middot; UPS &middot; Networking &middot; Monitors &middot; Printers &middot; AC &amp; more
            </p>
          </div>
          <div className="h-3 w-full" style={{ background: "linear-gradient(90deg, var(--yellow-500), var(--orange-500), var(--orange-700))" }} />
        </div>
        <p className="no-print mt-4 text-center text-[13px]" style={{ color: "var(--muted)" }}>
          {isCategory
            ? `This poster's QR opens your ${category} stock page (tagged "${campaign}" in Insights).`
            : "This poster's QR opens a WhatsApp chat."} In the print dialog choose "Save as PDF", or print on A4 for your shop.
        </p>
      </div>
    </div>
  );
}
